import CircularProgress from 'material-ui/CircularProgress';
import PropTypes from 'prop-types';
import r from 'render-dom';

import Button from 'components/ui/Button';

const propTypes = {
    error: PropTypes.object,
    pastDelay: PropTypes.bool,
    retry: PropTypes.func,
};

const style = {
    paddingTop: 100,
    textAlign: 'center',
};

export default function Loading({ error, pastDelay, retry }) {
    if (error) {
        return (
            r.div({ style }, [
                r.p(['Error!']),
                r(Button, { onClick: retry }, ['Retry']),
            ])
        );
    } else if (pastDelay) {
        return (
            r.div({ style }, [
                r(CircularProgress)
            ])
        );
    }

    return null;
}

Loading.propTypes = propTypes;
